'use strict'

var hasDims = require('./has_dimensions.js')

module.exports = function autoHighlight (image) {
    if (! hasDims(image)) throw new Error('Invalid image')

    var w
    var h
    var x
    var y

    var small_side = Math.min(image.height, image.width)
    w = h = Math.round(small_side / 2)
    x = (image.width - w) / 2
    y = (image.height - h) / 2

    return {
        x: x,
        y: y,
        w: w,
        h: h,
    }
}
